import styles from 'styles/modules/SidescreenEditCompanyInfo.module.scss';
import { useState } from 'react';

import { profile } from 'lang/en.json';
import Typo from 'components/Typo';
import { br2nl, nl2br } from '../../helpers/strings';

const LimitedTextArea = (props) => {
    const [val, setVal] = useState(br2nl(props.value) || '');

    const [counter, setCounter] = useState(props.limit - val.length);

    const handleChange = (e) => {
        const newVal = e.target.value;
        if (newVal.length > props.limit && newVal.length > val.length) {
            return;
        }
        setVal(newVal);
        setCounter(props.limit - newVal.length);
        const newValFormatted = nl2br(newVal);
        props.callback?.(newValFormatted);
    };

    return (
        <div className={styles.description}>
            <div className={['mb-xxs', styles.descriptionHeader].join(' ')}>
                <Typo variant={'body'} Tag={'label'} htmlFor="description">
                    {props.description}
                </Typo>

                <span className={styles.counter}>
                    <span className={counter < 10 ? styles.limited : ''}>
                        {counter}
                    </span>{' '}
                    {profile.header.details.sidebar.out_of} {props.limit}{' '}
                    {profile.header.details.sidebar.characters_left}
                </span>
            </div>
            <textarea
                name="description"
                id="description"
                className={styles.descriptionTextarea}
                onChange={handleChange}
                value={val}
                maxLength={props.limit}
                placeholder={
                    props.placeholder
                        ? props.placeholder
                        : props.isJournalist
                        ? profile.header.details.sidebar
                              .description_placeholder_journalist
                        : profile.header.details.sidebar.description_placeholder
                }
            />
        </div>
    );
};

export default LimitedTextArea;
